import SyncStatus from './SyncStatus'

export default SyncStatus
